import { render, staticRenderFns } from "./ProfilesGrid.vue?vue&type=template&id=3820d3ef"
import script from "./ProfilesGrid.vue?vue&type=script&lang=js"
export * from "./ProfilesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports